import { isEmpty } from 'lodash';

const checkDisabledButton = (field) => {
  const type = field?.approvalType?.value;

  switch (type) {
    case 1:
      return isEmpty(field?.reason) || isEmpty(field?.files) || isEmpty(field?.targetScheduleId) || isEmpty(field?.host);

    case 2:
    default:
      return isEmpty(field?.reason) || isEmpty(field?.files) || isEmpty(field?.hostChangeHost);
  }
};

export default checkDisabledButton;
